// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".table tr.is-selected td[data-v-216d27bc]{color:currentColor!important}.truncate[data-v-216d27bc]{overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:block-axis;vertical-align:middle;min-height:2rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
